import { get } from 'lodash';

export const getToken = (state) => state.session.accessToken;
export const getBankId = (state) => state.session.bankId;
export const getClientContext = (state) => state.session.clientContext;
export const hasAddPopoverBeenRead = (state) => state.session.hasAddPopoverBeenRead;
export const getIsLCV = (state) => get(state, 'session.isLCV', false);
export const getIsSme = (state) => get(state, 'session.isSme', false);
export const getHasGroupApprovalsEnabled = (state) => get(state, 'session.hasGroupApprovalsEnabled', false);
